import type { LicenseLimitUsage } from "@octopusdeploy/octopus-server-client";
import { HostingEnvironment, LimitStatus } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { getLimitsWithAlerts } from "~/areas/configuration/components/LicenseUsage/LicenseUsageDashboardPage";
import { repository } from "../../../clientInstance";
import { NotificationType } from "../notifications.redux";
import { NotificationPoller } from "./NotificationPoller";
import * as notificationLocalState from "./notificationLocalState";
export default class LicenceUsageNotificationPoller extends NotificationPoller {
    notificationId: string = "Notification/LicenceUsageCheck";
    notificationCheck = async () => {
        const licenseStatus = await repository.Licenses.getCurrentStatus();
        const licenseUsage = await repository.Licenses.getCurrentUsage();
        const licenseLimitsWithAlerts = getLimitsWithAlerts(licenseUsage.Limits);
        const licenseLimitsWitoutAlerts = licenseUsage.Limits.filter((limit) => !licenseLimitsWithAlerts.some((limitWithAlert: LicenseLimitUsage) => limitWithAlert.Name === limit.Name));
        const showLicenseUsageNotifications = licenseStatus.HostingEnvironment === HostingEnvironment.OctopusCloud && !!licenseLimitsWithAlerts.length;
        if (!showLicenseUsageNotifications) {
            licenseUsage.Limits.forEach((limit) => {
                notificationLocalState.clearValue(`${this.notificationId}${limit.Name}`);
            });
            return;
        }
        // clear all notifications that are not relevant anymore (for example, if a limit has been increased)
        licenseLimitsWitoutAlerts.forEach((limit) => {
            notificationLocalState.clearValue(`${this.notificationId}${limit.Name}`);
        });
        // push notifications for limits that are relevant
        licenseLimitsWithAlerts.forEach((limit) => {
            const notificationTitle = this.getNotificationTitle(limit);
            this.raiseNotification({
                id: `${this.notificationId}${limit.Name}`,
                text: notificationTitle,
                description: "",
                links: [{ type: "Internal", label: "View License Usage", href: links.licenseUsageDashboardPage.generateUrl() }],
                type: limit.LimitStatus === LimitStatus.AlmostAtLimit ? NotificationType.warn : NotificationType.error,
            });
        });
    };
    private getNotificationTitle(limit: LicenseLimitUsage): string {
        const resourceName = limit.Name.toLowerCase();
        switch (limit.LimitStatus) {
            case LimitStatus.ExceedingLimit:
            case LimitStatus.InOverrun:
                return `You have exceeded your ${resourceName} limit`;
            case LimitStatus.AtLimit:
                return `You have reached your ${resourceName} limit`;
            case LimitStatus.AlmostAtLimit:
                return `You are approaching your ${resourceName} limit`;
            default:
                return "";
        }
    }
}
